// src/config/admins.js
// Hardcoded list of administrator emails.
// Any user logging in with one of these emails gets admin privileges
// (access to /admin panel, can approve/reject certificates).

export const ADMIN_EMAILS = [
  'danielq19@gmail.com',
  'gerencia@ultrapharmacorp.us',
];

export const isAdminEmail = (email) =>
  !!email && ADMIN_EMAILS.map(e => e.toLowerCase()).includes(email.toLowerCase());
